var map = {
	"./alargarvidautil.png": 2809,
	"./ciclodevida.png": 7213,
	"./circularynormativas.png": 4957,
	"./comunicacionformacion.png": 6991,
	"./cooperacionempresarial.png": 1655,
	"./digitalizacion.png": 8656,
	"./ecodiseno.png": 7931,
	"./gestionrecursos.png": 4221,
	"./residuos.png": 9539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;